import { render, staticRenderFns } from "./ScreenCounterModal.vue?vue&type=template&id=35c7f94d&"
import script from "./ScreenCounterModal.vue?vue&type=script&lang=js&"
export * from "./ScreenCounterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports